import { Address } from './address';
import { PrescripteurContact } from './prescripteurContact';
import { Region } from './region';
import { TypeStructure } from './typeStructure';

export class Prescripteur {
	id: number;
	nomStructure: string;
	addressStructure: Address;
	typeStructure: TypeStructure;
	contacts: PrescripteurContact[];
	region: Region;
	

	constructor(
		options: {
			id?: number;
			nomStucture?: string;
			addressStructure?: Address;
			typeStructure?: TypeStructure;
		} = {}
	) {
		this.id = options.id || null;
		this.nomStructure = options.nomStucture || null;
		this.addressStructure = options.addressStructure || new Address();
		this.typeStructure = options.typeStructure || new TypeStructure();
	}
}
